import yearBook from '@/api/year-book'
import { baseState, baseMutations } from '@/store/mixins'

export const state = {
  ...baseState
}

export const getters = {}

export const mutations = {
  ...baseMutations
}

export const actions = {
  formView(context, options = {}) {
    return yearBook.formViewModel({ params: options })
  }
}
